import { Spinner, Text } from '@viapeople/components'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

interface RatingByDepartmentChartProps {
	data: Array<{ department: string; avgRating: number; count: number; highPerformerPercent: number }> | undefined
	loading?: boolean
}

export function RatingByDepartmentChart({ data, loading }: RatingByDepartmentChartProps) {
	if (loading) {
		return (
			<div data-testid='department-rating-loading' className='flex items-center justify-center h-64'>
				<Spinner />
			</div>
		)
	}
	if (!data || data.length === 0) {
		return (
			<div data-testid='department-rating-empty' className='flex items-center justify-center h-64 text-neutral-500'>
				No department data available for the current filters.
			</div>
		)
	}

	return (
		<div data-testid='rating-by-department-chart' className='w-full'>
			<Text variant='small' weight='semibold' className='mb-2'>
				Rating by Department
			</Text>
			<ResponsiveContainer width='100%' height={300}>
				<BarChart data={data} margin={{ top: 16, right: 24, left: 16, bottom: 24 }}>
					<CartesianGrid strokeDasharray='3 3' stroke='#e5e7eb' />
					<XAxis dataKey='department' tick={{ fontSize: 12 }} />
					<YAxis tick={{ fontSize: 12 }} domain={[0, 5]} />
					<Tooltip
						contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #e5e7eb' }}
						formatter={(value: number | undefined) => (value != null ? value.toFixed(2) : '-')}
					/>
					<Bar dataKey='avgRating' fill='#0891b2' name='Avg Rating' radius={[2, 2, 0, 0]} />
				</BarChart>
			</ResponsiveContainer>
		</div>
	)
}
